import { Column } from '@tanstack/react-table'

import { Table } from '@/components'
import { TablePropertiesContextProvider } from '@/components/Properties'
import { PropertiesChangeCallback } from '@/components/Properties/types'
import { StereotypeTitle } from '@/components/TableAndProperties/styles'
import { LastEditedCellProps } from '@/components/TableAndProperties/types'
import { useAppContext } from '@/hooks'
import { ItemType, TableColumnProps } from '@/types'

interface MainTableProps {
	columns: Column<any>[]
	handleChange: PropertiesChangeCallback
	handleDelete: (deletedItem: ItemType) => void
	isEditMode: boolean
	isReadonly: ((item: ItemType) => boolean) | undefined
	items: ItemType[]
	lastEditedCell: LastEditedCellProps
	maxWidth?: number
	onSaveData: (newItems: ItemType[]) => void
	properties: TableColumnProps<ItemType, any>[]
	technicalColumns: ItemType[] | undefined
}

export const MainTable = ({
	columns,
	handleChange,
	handleDelete,
	isEditMode,
	isReadonly,
	items,
	lastEditedCell,
	maxWidth,
	onSaveData,
	properties,
	technicalColumns,
}: MainTableProps) => {
	const { t } = useAppContext()

	return (
		<div>
			<TablePropertiesContextProvider
				properties={properties}
				items={items}
				readonly={!isEditMode}
				isReadonly={isReadonly}
			>
				<Table
					columns={columns}
					data={items}
					isEditMode={isEditMode}
					hasLastRowEdit={false}
					handleChange={handleChange}
					onDelete={handleDelete}
					onSaveData={onSaveData}
					lastEditedCell={lastEditedCell}
					maxWidth={maxWidth}
					scrollWithParent
				/>
			</TablePropertiesContextProvider>
			{technicalColumns && technicalColumns.length > 0 && (
				<TablePropertiesContextProvider
					properties={properties}
					items={items}
					readonly
				>
					<StereotypeTitle>{t('TECHNICAL_COLUMNS_TITLE')}</StereotypeTitle>
					<Table
						columns={columns}
						data={technicalColumns}
						hasLastRowEdit={false}
						isEditMode={false}
						handleChange={handleChange}
						onDelete={handleDelete}
						onSaveData={onSaveData}
						scrollWithParent
					/>
				</TablePropertiesContextProvider>
			)}
		</div>
	)
}
